import React from "react"
import { WarningModal } from "./WarningModal"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"

interface ConfirmationModalProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  confirmLoading?: boolean
  cancelButtonText?: string
  confirmButtonText?: string
  title?: string
  dialogAriaLabel?: string
  confirmationText?: string
  hideIconAndTitle?: boolean
  hideCancelButton?: boolean
  usePrimaryButtonType?: boolean
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  confirmLoading = false,
  cancelButtonText,
  confirmButtonText,
  confirmationText,
  title,
  dialogAriaLabel,
  hideIconAndTitle,
  hideCancelButton,
  usePrimaryButtonType,
}) => {
  const { cms: cmsContent } = useCMSReady(["common"])
  const commonText = cmsContent.common
  if (!commonText) return null
  return (
    <WarningModal
      isOpen={isOpen}
      onConfirm={onConfirm}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      text={{
        title: title || commonText?.warningDialogTitle,
        cancelButton: cancelButtonText || commonText?.cancel,
        confirmButton: confirmButtonText || commonText?.accept,
        dialogAriaLabel: dialogAriaLabel,
      }}
      hideIconAndTitle={hideIconAndTitle}
      hideCancelButton={hideCancelButton}
      usePrimaryButtonType={usePrimaryButtonType}
    >
      {confirmationText}
    </WarningModal>
  )
}

export default ConfirmationModal
